module.exports = __webpack_public_path__ + "img/right4.8b4d8782.png";